import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=dd9c192e&"
import script from "./DataSource.vue?vue&type=script&lang=js&"
export * from "./DataSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports